import { Fab, styled } from '@mui/material'
import { FC } from 'react'
import CloseIcon from '@mui/icons-material/Close'

export const StyledFab = styled(Fab)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
  minHeight: 'auto',
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '& .MuiSvgIcon-root': {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
}))

export const CloseModalButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <StyledFab color="default" aria-label="close" onClick={onClick}>
      <CloseIcon />
    </StyledFab>
  )
}
